<div
    fxLayout="column"
    class="add-notes-dialog-component gap-16 padding-12 full-width full-height"
>
    <div
        fxLayout="row"
        class="add-notes-dialog-component__header"
        fxLayoutAlign="space-between center"
    >
        <h1 class="text-16-semi-bold color-text-primary">
            {{ data.visualization?.note ? "Editar Nota" : "Adicionar Nota" }}
        </h1>
        <dsn-button-menu-chips
            [mainIcon]="'fa-solid fa-xmark'"
            size="medium"
            (onClick)="this.dialogRef.close()"
        ></dsn-button-menu-chips>
    </div>
    <div fxLayout="column" class="gap-8">
        <p class="text-14-semi-bold color-text-primary">
            {{ data.visualization.props.name }}
        </p>

        <div
            class="add-notes-dialog-component__section full-height gap-8"
            fxFlex
        >
            <div
                class="add-noted-dialog-component__input"
                fxLayout="column"
                fxFlex
            >
                <dsn-rich-text-input
                    [size]="'small'"
                    [placeholder]="
                        'Escreva aqui a sua análise para este Indicador.'
                    "
                    [disabled]="false"
                    [value]="comment"
                    [name]="'username'"
                    [id]="'username-field'"
                    [noValidate]="true"
                    [invalidMessage]="''"
                    [bordered]="false"
                    (onValueChange)="handleInput($event)"
                ></dsn-rich-text-input>
                <span
                    class="color-text-medium text-10-regular"
                    [style.opacity]="data.visualization.note ? '1' : '0.5'"
                    >{{
                        data.visualization?.note?.createdAtTimeString || ""
                    }}</span
                >
            </div>
        </div>
        @if (accountingPlanService.features["IAShortcutsAccounting"]) {
            <dsn-button
                [label]="
                    generatingNote ? 'Gerando nota...' : 'Criar nota com IA'
                "
                [type]="'tertiary'"
                [size]="'medium'"
                [iconLeftCustom]="
                    generatingNote ? '' : '/images/logos/nanda-icon-logo.svg'
                "
                [active]="false"
                [fontWeight]="'bold'"
                [typeButton]="'button'"
                [iconSizeCustom]="'large'"
                [disabled]="loading"
                style="margin-top: var(--spacing-12); width: fit-content"
                class="button-generate-note"
                (onClick)="onGenerateNote()"
                [disabled]="loading"
                [loading]="generatingNote"
            ></dsn-button>
        }
    </div>
    <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="gap-12 full-width"
    >
        @if (data.visualization?.note) {
            <dsn-button
                [label]="'Excluir nota'"
                [type]="'secondary-alert'"
                [size]="'medium'"
                [disabled]="
                    !data?.visualization?.note?.props?._id ||
                    loading ||
                    !data.visualization?.note?.props?.comment
                "
                [iconLeft]="'fa-solid fa-trash-can'"
                [active]="false"
                style="width: 100%"
                (onClick)="handleRemoveNote()"
            ></dsn-button>
        }
        <div
            fxLayout="row"
            class="gap-16 full-width"
            fxLayoutAlign="end center"
        >
            <dsn-button
                [label]="'Cancelar'"
                [type]="'outline'"
                [size]="'medium'"
                [disabled]="loading"
                [iconRight]="''"
                [active]="false"
                (onClick)="dialogRef.close()"
            ></dsn-button>
            <dsn-button
                [label]="'Salvar'"
                [type]="'primary'"
                [size]="'medium'"
                [disabled]="
                    loading ||
                    (this.isContentEmpty(comment) &&
                        this.isContentEmpty(
                            data.visualization?.note?.props?.comment
                        ))
                "
                [iconRight]="''"
                [active]="false"
                (onClick)="handleSubmit()"
            ></dsn-button>
        </div>
    </div>
</div>
